(function () {
  'use strict';

  var DIAL_CODES = {
    AF:"93",AL:"355",DZ:"213",AD:"376",AO:"244",AG:"1",AR:"54",AM:"374",AU:"61",AT:"43",
    AZ:"994",BS:"1",BH:"973",BD:"880",BB:"1",BY:"375",BE:"32",BZ:"501",BJ:"229",BT:"975",
    BO:"591",BA:"387",BW:"267",BR:"55",BN:"673",BG:"359",BF:"226",BI:"257",CV:"238",KH:"855",
    CM:"237",CA:"1",CF:"236",TD:"235",CL:"56",CN:"86",CO:"57",KM:"269",CG:"242",CR:"506",
    HR:"385",CU:"53",CY:"357",CZ:"420",DK:"45",DJ:"253",DM:"1",DO:"1",EC:"593",EG:"20",
    SV:"503",GQ:"240",ER:"291",EE:"372",SZ:"268",ET:"251",FJ:"679",FI:"358",FR:"33",GA:"241",
    GM:"220",GE:"995",DE:"49",GH:"233",GR:"30",GD:"1",GT:"502",GN:"224",GW:"245",GY:"592",
    HT:"509",HN:"504",HU:"36",IS:"354",IN:"91",ID:"62",IR:"98",IQ:"964",IE:"353",IL:"972",
    IT:"39",CI:"225",JM:"1",JP:"81",JO:"962",KZ:"7",KE:"254",KI:"686",XK:"383",KW:"965",
    KG:"996",LA:"856",LV:"371",LB:"961",LS:"266",LR:"231",LY:"218",LI:"423",LT:"370",LU:"352",
    MG:"261",MW:"265",MY:"60",MV:"960",ML:"223",MT:"356",MH:"692",MR:"222",MU:"230",MX:"52",
    FM:"691",MD:"373",MC:"377",MN:"976",ME:"382",MA:"212",MZ:"258",MM:"95",NA:"264",NR:"674",
    NP:"977",NL:"31",NZ:"64",NI:"505",NE:"227",NG:"234",KP:"850",MK:"389",NO:"47",OM:"968",
    PK:"92",PW:"680",PS:"970",PA:"507",PG:"675",PY:"595",PE:"51",PH:"63",PL:"48",PT:"351",
    QA:"974",RO:"40",RU:"7",RW:"250",KN:"1",LC:"1",VC:"1",WS:"685",SM:"378",ST:"239",
    SA:"966",SN:"221",RS:"381",SC:"248",SL:"232",SG:"65",SK:"421",SI:"386",SB:"677",SO:"252",
    ZA:"27",KR:"82",SS:"211",ES:"34",LK:"94",SD:"249",SR:"597",SE:"46",CH:"41",SY:"963",
    TW:"886",TJ:"992",TZ:"255",TH:"66",TL:"670",TG:"228",TO:"676",TT:"1",TN:"216",TR:"90",
    TM:"993",TV:"688",UG:"256",UA:"380",AE:"971",GB:"44",US:"1",UY:"598",UZ:"998",VU:"678",
    VA:"379",VE:"58",VN:"84",YE:"967",ZM:"260",ZW:"263"
  };
  var COUNTRY_NAMES = {
    AF:"Afghanistan",AL:"Albania",DZ:"Algeria",AD:"Andorra",AO:"Angola",AG:"Antigua and Barbuda",AR:"Argentina",AM:"Armenia",AU:"Australia",AT:"Austria",
    AZ:"Azerbaijan",BS:"Bahamas",BH:"Bahrain",BD:"Bangladesh",BB:"Barbados",BY:"Belarus",BE:"Belgium",BZ:"Belize",BJ:"Benin",BT:"Bhutan",
    BO:"Bolivia",BA:"Bosnia and Herzegovina",BW:"Botswana",BR:"Brazil",BN:"Brunei",BG:"Bulgaria",BF:"Burkina Faso",BI:"Burundi",CV:"Cabo Verde",KH:"Cambodia",
    CM:"Cameroon",CA:"Canada",CF:"Central African Republic",TD:"Chad",CL:"Chile",CN:"China",CO:"Colombia",KM:"Comoros",CG:"Congo (Congo-Brazzaville)",CR:"Costa Rica",
    HR:"Croatia",CU:"Cuba",CY:"Cyprus",CZ:"Czechia",DK:"Denmark",DJ:"Djibouti",DM:"Dominica",DO:"Dominican Republic",EC:"Ecuador",EG:"Egypt",
    SV:"El Salvador",GQ:"Equatorial Guinea",ER:"Eritrea",EE:"Estonia",SZ:"Eswatini",ET:"Ethiopia",FJ:"Fiji",FI:"Finland",FR:"France",GA:"Gabon",
    GM:"Gambia",GE:"Georgia",DE:"Germany",GH:"Ghana",GR:"Greece",GD:"Grenada",GT:"Guatemala",GN:"Guinea",GW:"Guinea-Bissau",GY:"Guyana",
    HT:"Haiti",HN:"Honduras",HU:"Hungary",IS:"Iceland",IN:"India",ID:"Indonesia",IR:"Iran",IQ:"Iraq",IE:"Ireland",IL:"Israel",
    IT:"Italy",CI:"Ivory Coast",JM:"Jamaica",JP:"Japan",JO:"Jordan",KZ:"Kazakhstan",KE:"Kenya",KI:"Kiribati",XK:"Kosovo",KW:"Kuwait",
    KG:"Kyrgyzstan",LA:"Laos",LV:"Latvia",LB:"Lebanon",LS:"Lesotho",LR:"Liberia",LY:"Libya",LI:"Liechtenstein",LT:"Lithuania",LU:"Luxembourg",
    MG:"Madagascar",MW:"Malawi",MY:"Malaysia",MV:"Maldives",ML:"Mali",MT:"Malta",MH:"Marshall Islands",MR:"Mauritania",MU:"Mauritius",MX:"Mexico",
    FM:"Micronesia",MD:"Moldova",MC:"Monaco",MN:"Mongolia",ME:"Montenegro",MA:"Morocco",MZ:"Mozambique",MM:"Myanmar",NA:"Namibia",NR:"Nauru",
    NP:"Nepal",NL:"Netherlands",NZ:"New Zealand",NI:"Nicaragua",NE:"Niger",NG:"Nigeria",KP:"North Korea",MK:"North Macedonia",NO:"Norway",OM:"Oman",
    PK:"Pakistan",PW:"Palau",PS:"Palestine",PA:"Panama",PG:"Papua New Guinea",PY:"Paraguay",PE:"Peru",PH:"Philippines",PL:"Poland",PT:"Portugal",
    QA:"Qatar",RO:"Romania",RU:"Russia",RW:"Rwanda",KN:"Saint Kitts and Nevis",LC:"Saint Lucia",VC:"Saint Vincent and the Grenadines",WS:"Samoa",SM:"San Marino",ST:"Sao Tome and Principe",
    SA:"Saudi Arabia",SN:"Senegal",RS:"Serbia",SC:"Seychelles",SL:"Sierra Leone",SG:"Singapore",SK:"Slovakia",SI:"Slovenia",SB:"Solomon Islands",SO:"Somalia",
    ZA:"South Africa",KR:"South Korea",SS:"South Sudan",ES:"Spain",LK:"Sri Lanka",SD:"Sudan",SR:"Suriname",SE:"Sweden",CH:"Switzerland",SY:"Syria",
    TW:"Taiwan",TJ:"Tajikistan",TZ:"Tanzania",TH:"Thailand",TL:"Timor-Leste",TG:"Togo",TO:"Tonga",TT:"Trinidad and Tobago",TN:"Tunisia",TR:"Turkey",
    TM:"Turkmenistan",TV:"Tuvalu",UG:"Uganda",UA:"Ukraine",AE:"United Arab Emirates",GB:"United Kingdom",US:"United States",UY:"Uruguay",UZ:"Uzbekistan",VU:"Vanuatu",
    VA:"Vatican City",VE:"Venezuela",VN:"Vietnam",YE:"Yemen",ZM:"Zambia",ZW:"Zimbabwe"
  };
  var PRIMARY_FOR_DIAL = { "1": "US", "7": "RU" };

  function findCountryByDial(digitsOnly) {
    var maxLen = Math.min(4, digitsOnly.length);
    for (var len = maxLen; len >= 1; len--) {
      var candidate = digitsOnly.slice(0, len);
      if (PRIMARY_FOR_DIAL[candidate]) return { code: PRIMARY_FOR_DIAL[candidate], dial: candidate };
      for (var code in DIAL_CODES) {
        if (DIAL_CODES[code] === candidate) return { code: code, dial: candidate };
      }
    }
    return null;
  }

  function initSpin(root) {
    var excludedPaths = (root.getAttribute('data-excluded-paths') || '')
      .split('\n').map(function (p) { return p.trim(); }).filter(Boolean);
    var currentPath = window.location.pathname;
    if (excludedPaths.some(function (p) { return currentPath === p || currentPath.indexOf(p) === 0; })) {
      return;
    }

    var endpoint = root.getAttribute('data-worker-endpoint').replace(/\/?$/, '');
    var trigger = root.getAttribute('data-trigger');
    var delaySec = parseInt(root.getAttribute('data-delay'), 10) || 5;
    var shopUrl = root.getAttribute('data-shop-url') || '/collections/hearing-aids';
    var urgencyMessage = root.getAttribute('data-urgency-message') || '';
    var resultHeadingTemplate = root.getAttribute('data-result-heading-template') || 'You Won {prize}!';

    var overlay = root.querySelector('[data-spin-overlay]');
    var closeBtn = root.querySelector('[data-spin-close]');
    var reopenBtn = root.querySelector('[data-spin-open]');
    var declineBtn = root.querySelector('[data-spin-decline]');
    var entryView = root.querySelector('[data-spin-entry]');
    var resultView = root.querySelector('[data-spin-result]');
    var form = root.querySelector('[data-spin-form]');
    var errorEl = root.querySelector('[data-spin-error]');
    var submitBtn = root.querySelector('[data-spin-submit]');
    var wheelEl = root.querySelector('[data-spin-wheel]');
    var resultTitle = root.querySelector('[data-spin-result-title]');
    var codeEl = root.querySelector('[data-spin-code]');
    var copyBtn = root.querySelector('[data-spin-copy]');
    var shopLink = root.querySelector('[data-spin-shop-link]');
    var conditionEl = root.querySelector('[data-spin-condition]');
    var urgencyEl = root.querySelector('[data-spin-urgency]');
    var countdownEl = root.querySelector('[data-spin-countdown]');
    var countdownLabelTemplate = root.getAttribute('data-countdown-label-template') || 'Expires in {timer}';
    var stickyCountdownTemplate = root.getAttribute('data-sticky-countdown-template') || 'Expires in {timer}';
    var expiredText = root.getAttribute('data-expired-text') || 'Code Expired';
    var countdownIntervalId = null;

    // ===================== Phone country combo =====================
    var phoneCombo = root.querySelector('[data-spin-phone-combo]');
    var phoneTrigger = root.querySelector('[data-spin-phone-trigger]');
    var phoneTriggerFlag = root.querySelector('[data-spin-phone-flag]');
    var phoneTriggerCode = root.querySelector('[data-spin-phone-code]');
    var phoneDropdown = root.querySelector('[data-spin-phone-dropdown]');
    var phoneSearchInput = root.querySelector('[data-spin-phone-search]');
    var phoneList = root.querySelector('[data-spin-phone-list]');
    var phoneLocalInput = form.querySelector('input[name="phone_local"]');
    var detectedDialCode = '1';
    var currentCountryCode = 'US';

    function applyDialCode(countryCode) {
      var cc = (countryCode || 'US').toUpperCase();
      if (!DIAL_CODES[cc]) cc = 'US';
      currentCountryCode = cc;
      detectedDialCode = DIAL_CODES[cc];
      if (phoneTriggerFlag) phoneTriggerFlag.className = 'fi fi-' + cc.toLowerCase() + ' hs-phone-trigger-flag';
      if (phoneTriggerCode) phoneTriggerCode.textContent = '+' + detectedDialCode;
      if (phoneList) {
        phoneList.querySelectorAll('.hs-phone-dropdown-item').forEach(function (item) {
          item.classList.toggle('is-active', item.getAttribute('data-code') === cc);
        });
      }
    }

    function buildPhoneList(filterText) {
      if (!phoneList) return;
      var q = (filterText || '').trim().toLowerCase();
      var codes = Object.keys(DIAL_CODES).sort(function (a, b) {
        return (COUNTRY_NAMES[a] || a).localeCompare(COUNTRY_NAMES[b] || b);
      });
      phoneList.innerHTML = '';
      var shown = 0;
      codes.forEach(function (code) {
        var name = COUNTRY_NAMES[code] || code;
        var dial = DIAL_CODES[code];
        if (q && name.toLowerCase().indexOf(q) === -1 && code.toLowerCase().indexOf(q) === -1 && dial.indexOf(q.replace('+', '')) === -1) return;
        shown++;
        var item = document.createElement('div');
        item.className = 'hs-phone-dropdown-item' + (code === currentCountryCode ? ' is-active' : '');
        item.setAttribute('role', 'option');
        item.setAttribute('data-code', code);
        item.innerHTML =
          '<span class="fi fi-' + code.toLowerCase() + '"></span>' +
          '<span class="hs-phone-dropdown-name"></span>' +
          '<span class="hs-phone-dropdown-dial">+' + dial + '</span>';
        item.querySelector('.hs-phone-dropdown-name').textContent = name;
        item.addEventListener('mousedown', function (e) {
          e.preventDefault();
          applyDialCode(code);
          closePhoneDropdown();
          if (phoneLocalInput) phoneLocalInput.focus();
        });
        phoneList.appendChild(item);
      });
      if (!shown) phoneList.innerHTML = '<div class="hs-phone-dropdown-empty">No country found</div>';
    }

    function openPhoneDropdown() {
      if (!phoneDropdown) return;
      buildPhoneList('');
      phoneDropdown.hidden = false;
      phoneTrigger.setAttribute('aria-expanded', 'true');
      if (phoneSearchInput) { phoneSearchInput.value = ''; setTimeout(function () { phoneSearchInput.focus(); }, 30); }
    }
    function closePhoneDropdown() {
      if (!phoneDropdown) return;
      phoneDropdown.hidden = true;
      phoneTrigger.setAttribute('aria-expanded', 'false');
    }
    if (phoneTrigger) {
      phoneTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (phoneDropdown.hidden) openPhoneDropdown(); else closePhoneDropdown();
      });
    }
    if (phoneSearchInput) phoneSearchInput.addEventListener('input', function () { buildPhoneList(phoneSearchInput.value); });
    document.addEventListener('click', function (e) {
      if (phoneCombo && !phoneCombo.contains(e.target)) closePhoneDropdown();
    });

    applyDialCode('US');
    fetch(endpoint + '/geo')
      .then(function (r) { return r.json(); })
      .then(function (d) { applyDialCode(d && d.country); })
      .catch(function () {});

    if (phoneLocalInput) {
      phoneLocalInput.addEventListener('input', function () {
        if (phoneLocalInput._syncing) return;
        var val = phoneLocalInput.value;
        var prefixMatch = val.match(/^\s*(?:\+|00)(\d{1,4})/);
        if (prefixMatch) {
          var match = findCountryByDial(prefixMatch[1]);
          if (match) {
            applyDialCode(match.code);
            var stripRe = new RegExp('^\\s*(?:\\+|00)\\d{' + match.dial.length + '}[\\s-]*');
            val = val.replace(stripRe, '');
          }
        }
        var cleaned = val.replace(/\D/g, '').slice(0, 12);
        phoneLocalInput._syncing = true;
        phoneLocalInput.value = cleaned;
        phoneLocalInput._syncing = false;
      });
    }
    // ===================== end phone combo =====================

    var dismissKey = 'hs_spin_dismissed';
    var wonDataKey = 'hs_spin_won_data';
    var WON_DATA_TTL_MS = 1000 * 60 * 60 * 24 * 7;

    function getWonData() {
      try {
        var raw = localStorage.getItem(wonDataKey);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed.saved_at || (Date.now() - parsed.saved_at) > WON_DATA_TTL_MS) {
          localStorage.removeItem(wonDataKey);
          return null;
        }
        return parsed;
      } catch (e) { return null; }
    }
    function setWonData(data) {
      try {
        data.saved_at = Date.now();
        localStorage.setItem(wonDataKey, JSON.stringify(data));
      } catch (e) {}
    }

    var placeholders = Array.prototype.slice.call(wheelEl.querySelectorAll('[data-prize-index]'));
    var prizes = placeholders.map(function (el) {
      return {
        label: el.getAttribute('data-label'),
        color: el.getAttribute('data-color'),
        type: el.getAttribute('data-discount-type'),
        value: Number(el.getAttribute('data-discount-value')),
        weight: Number(el.getAttribute('data-weight')) || 1,
        min_order_value: Number(el.getAttribute('data-min-order')) || 0
      };
    });
    wheelEl.innerHTML = '';

    var n = prizes.length;
    var wheelGroup = null;
    if (n > 0) {
      var segAngle = 360 / n;
      var SVG_NS = 'http://www.w3.org/2000/svg';
      var size = 300;
      var cx = size / 2, cy = size / 2, r = size / 2 - 4;

      function polar(angleDeg, radius) {
        var rad = (angleDeg * Math.PI) / 180;
        return {
          x: cx + radius * Math.sin(rad),
          y: cy - radius * Math.cos(rad)
        };
      }

      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
      svg.setAttribute('class', 'hs-spin__wheel-svg');

      wheelGroup = document.createElementNS(SVG_NS, 'g');
      wheelGroup.style.transformOrigin = cx + 'px ' + cy + 'px';
      wheelGroup.style.transition = 'transform 4.2s cubic-bezier(0.17, 0.67, 0.14, 1)';
      svg.appendChild(wheelGroup);

      prizes.forEach(function (p, i) {
        var startAngle = i * segAngle;
        var endAngle = (i + 1) * segAngle;
        var p1 = polar(startAngle, r);
        var p2 = polar(endAngle, r);
        var largeArc = (endAngle - startAngle) > 180 ? 1 : 0;
        var path = document.createElementNS(SVG_NS, 'path');
        var d = 'M ' + cx + ',' + cy + ' L ' + p1.x + ',' + p1.y +
          ' A ' + r + ',' + r + ' 0 ' + largeArc + ',1 ' + p2.x + ',' + p2.y + ' Z';
        path.setAttribute('d', d);
        path.setAttribute('fill', p.color);
        path.setAttribute('stroke', '#ffffff');
        path.setAttribute('stroke-width', '2');
        wheelGroup.appendChild(path);
      });

      prizes.forEach(function (p, i) {
        var centerAngle = (i + 0.5) * segAngle;
        var pos = polar(centerAngle, r * 0.6);
        var text = document.createElementNS(SVG_NS, 'text');
        text.setAttribute('x', pos.x);
        text.setAttribute('y', pos.y);
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('dominant-baseline', 'middle');
        text.setAttribute('class', 'hs-spin__seg-text');
        text.textContent = p.label;

        var rotation = centerAngle - 90;
        rotation = ((rotation % 360) + 360) % 360;
        if (rotation > 90 && rotation < 270) rotation += 180;
        text.setAttribute('transform', 'rotate(' + rotation + ' ' + pos.x + ' ' + pos.y + ')');

        wheelGroup.appendChild(text);
      });

      wheelEl.innerHTML = '';
      wheelEl.appendChild(svg);

      var centerDot = document.createElement('div');
      centerDot.className = 'hs-spin__wheel-center';
      centerDot.textContent = root.getAttribute('data-hub-text') || 'SPIN';
      wheelEl.appendChild(centerDot);
    }

    function formatTimer(ms) {
      if (ms <= 0) return '00:00:00';
      var totalSec = Math.floor(ms / 1000);
      var days = Math.floor(totalSec / 86400);
      var hours = Math.floor((totalSec % 86400) / 3600);
      var mins = Math.floor((totalSec % 3600) / 60);
      var secs = totalSec % 60;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      return (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
    }

    function startCountdown(expiresAt) {
      if (countdownIntervalId) clearInterval(countdownIntervalId);
      if (!expiresAt) {
        if (countdownEl) countdownEl.hidden = true;
        return;
      }
      var expiryTime = new Date(expiresAt).getTime();

      function tick() {
        var remaining = expiryTime - Date.now();
        if (remaining <= 0) {
          clearInterval(countdownIntervalId);
          if (countdownEl) { countdownEl.textContent = expiredText; countdownEl.hidden = false; }
          reopenBtn.textContent = expiredText;
          reopenBtn.setAttribute('data-expired', 'true');
          return;
        }
        var timerStr = formatTimer(remaining);
        if (countdownEl) { countdownEl.textContent = countdownLabelTemplate.replace('{timer}', timerStr); countdownEl.hidden = false; }
        if (reopenBtn.getAttribute('data-won') === 'true') {
          reopenBtn.textContent = stickyCountdownTemplate.replace('{timer}', timerStr);
        }
      }
      tick();
      countdownIntervalId = setInterval(tick, 1000);
    }

    function renderResultView(data) {
      resultTitle.textContent = resultHeadingTemplate.replace('{prize}', data.prize_label);
      codeEl.textContent = data.discount_code;
      if (conditionEl) {
        if (data.min_order_value > 0) {
          conditionEl.textContent = 'Valid on orders of $' + data.min_order_value + ' or more.';
          conditionEl.hidden = false;
        } else {
          conditionEl.hidden = true;
        }
      }
      if (urgencyEl) {
        urgencyEl.textContent = urgencyMessage;
        urgencyEl.hidden = !urgencyMessage;
      }
      shopLink.href = '/discount/' + encodeURIComponent(data.discount_code) + '?redirect=' + encodeURIComponent(shopUrl);
      startCountdown(data.expires_at);
    }

    function setStickyToCode(code) {
      reopenBtn.textContent = code;
      reopenBtn.setAttribute('data-won', 'true');
      reopenBtn.hidden = false;
    }

    var wonData = getWonData();

    function openPopup() {
      if (wonData) return;
      try { if (localStorage.getItem(dismissKey)) return; } catch (e) {}
      overlay.hidden = false;
    }
    function closePopup() {
      overlay.hidden = true;
      try { localStorage.setItem(dismissKey, '1'); } catch (e) {}
      if (!wonData) reopenBtn.hidden = false;
    }

    closeBtn.addEventListener('click', closePopup);
    declineBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });

    reopenBtn.addEventListener('click', function () {
      if (wonData) {
        entryView.hidden = true;
        resultView.hidden = false;
        overlay.hidden = false;
        return;
      }
      try { localStorage.removeItem(dismissKey); } catch (e) {}
      reopenBtn.hidden = true;
      overlay.hidden = false;
    });

    if (wonData) {
      setStickyToCode(wonData.discount_code);
      renderResultView(wonData);
    } else {
      if (trigger === 'load') openPopup();
      else if (trigger === 'delay') setTimeout(openPopup, delaySec * 1000);
      else if (trigger === 'exit') {
        document.addEventListener('mouseout', function onExit(e) {
          if (e.clientY > 0) return;
          openPopup();
          document.removeEventListener('mouseout', onExit);
        });
      }
      if (trigger === 'manual') reopenBtn.hidden = false;

      try {
        if (localStorage.getItem(dismissKey)) reopenBtn.hidden = false;
      } catch (e) {}
    }

    // Real source saved earlier by the "hs_touch" snippet in theme.liquid (used only when this visit has no source of its own).
    function readStoredTouch() {
      try {
        var t = JSON.parse(window.localStorage.getItem('hs_touch') || 'null');
        if (!t || !t.ts || (Date.now() - t.ts) > 30 * 86400000) return null;
        var sp = new URLSearchParams();
        ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { if (t[k]) sp.set(k, t[k]); });
        if (t.gclid) sp.set('gclid', '1');
        if (t.fbclid) sp.set('fbclid', '1');
        return { params: sp, referrer: t.referrer || '' };
      } catch (e) { return null; }
    }
    function detectTrafficSource() {
      var params = new URLSearchParams(window.location.search);
      var ref = document.referrer;
      var refIsOwn = false;
      try { refIsOwn = !!ref && new URL(ref).hostname.replace(/^www\./, '') === window.location.hostname.replace(/^www\./, ''); } catch (e) { /* ignore */ }
      if (!params.get('utm_source') && !params.get('gclid') && !params.get('fbclid') && (!ref || refIsOwn)) {
        var stored = readStoredTouch();
        if (stored) { params = stored.params; ref = stored.referrer; }
      }
      var utmSource = params.get('utm_source');
      var utmMedium = params.get('utm_medium');
      var utmCampaign = params.get('utm_campaign');
      if (params.get('gclid')) return { source: 'google_ads', medium: 'paid', campaign: utmCampaign };
      if (params.get('fbclid')) return { source: 'facebook_ads', medium: 'paid', campaign: utmCampaign };
      if (utmSource) return { source: utmSource, medium: utmMedium || 'unknown', campaign: utmCampaign };
      if (!ref) return { source: 'direct', medium: 'none', campaign: null };
      try {
        var refHost = new URL(ref).hostname.replace(/^www\./, '');
        var thisHost = window.location.hostname.replace(/^www\./, '');
        if (refHost === thisHost) return { source: 'internal', medium: 'site', campaign: null };
        if (/google\./.test(refHost)) return { source: 'google', medium: 'organic', campaign: null };
        if (/bing\./.test(refHost)) return { source: 'bing', medium: 'organic', campaign: null };
        if (/facebook\.|instagram\./.test(refHost)) return { source: refHost, medium: 'social', campaign: null };
        return { source: refHost, medium: 'referral', campaign: null };
      } catch (e) { return { source: 'unknown', medium: 'unknown', campaign: null }; }
    }
    function detectDeviceType() {
      var ua = navigator.userAgent || '';
      if (/tablet|ipad/i.test(ua)) return 'tablet';
      if (/mobile|android|iphone/i.test(ua)) return 'mobile';
      return 'desktop';
    }
    var analyticsContext = {
      trafficSource: detectTrafficSource(),
      deviceType: detectDeviceType(),
      landingPage: window.location.href,
      referrer: document.referrer || null,
      language: navigator.language || null,
      browserTimezone: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch (e) { return null; } })(),
    visitorId: (function () { try { var m = document.cookie.match(/(?:^|; )hs_vid=([^;]+)/); return m ? decodeURIComponent(m[1]).slice(0, 64) : null; } catch (e) { return null; } })()
    };

    var currentRotation = 0;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var fd = new FormData(form);
      var localPhone = phoneLocalInput ? phoneLocalInput.value.trim() : fd.get('phone_local');
      var payload = {
        name: fd.get('name'),
        email: fd.get('email'),
        phone: '+' + detectedDialCode + ' ' + localPhone,
        prizes: prizes,
        urgency_message: urgencyMessage,
        expiry_hours: root.getAttribute('data-expiry-hours'),
        site_origin: window.location.origin,
        shop_path: shopUrl,
        page_url: window.location.href,
        context: analyticsContext
      };

      submitBtn.disabled = true;
      var originalLabel = submitBtn.textContent;
      submitBtn.textContent = 'Spinning...';

      fetch(endpoint + '/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.message || d.error || 'Request failed'); });
          return res.json();
        })
        .then(function (data) {
          spinToIndex(data.chosen_index, function () {
            var result = {
              prize_label: data.prize_label,
              discount_code: data.discount_code,
              min_order_value: data.min_order_value || 0,
              expires_at: data.expires_at || null
            };
            setStickyToCode(result.discount_code);
            renderResultView(result);
            entryView.hidden = true;
            resultView.hidden = false;
            setWonData(result);
            wonData = result;
          });
        })
        .catch(function (err) {
          errorEl.textContent = 'Something went wrong — please try again.';
          errorEl.hidden = false;
          console.error('HearSilk spin-to-win error:', err);
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        });
    });

    function spinToIndex(index, onDone) {
      var segAngle = 360 / n;
      var centerAngle = (index + 0.5) * segAngle;
      var pointerAngle = 90;
      var extraSpins = 6 * 360;
      var targetWithinCircle = ((pointerAngle - centerAngle) % 360 + 360) % 360;
      currentRotation += extraSpins + targetWithinCircle - (currentRotation % 360);

      wheelGroup.style.transform = 'rotate(' + currentRotation + 'deg)';

      var handled = false;
      function onTransitionEnd() {
        if (handled) return;
        handled = true;
        wheelGroup.removeEventListener('transitionend', onTransitionEnd);
        onDone();
      }
      wheelGroup.addEventListener('transitionend', onTransitionEnd);
      setTimeout(onTransitionEnd, 4500);
    }

    copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = 'Copied!';
          copyBtn.setAttribute('data-copied', 'true');
          setTimeout(function () {
            copyBtn.textContent = 'Copy';
            copyBtn.removeAttribute('data-copied');
          }, 2000);
        });
      }
    });
  }
  document.querySelectorAll('[data-spin-root]').forEach(initSpin);
})();